import {Routes} from '@angular/router';
import {MnewsDistComponent} from './mnews-dist/mnews-dist.component';
import {mnewsDistRoutes} from './mnews-dist/mnews-dist.routes';
import {AuthGuard} from './common/_gaurd/auth.guard';
import {AuthComponent} from './auth/auth.component';
import {Grievance} from './mnews-dist/_services/_modals/grievance.modal';
import {GrievanceComponent} from './mnews-dist/_components/grievance/grievance.component';
import {GrievanceListComponent} from './mnews-dist/_components/grievance-list/grievance-list.component';
import {MainComponent} from './mnews-dist/_components/main/main.component';
import {ApiListComponent} from './mnews-dist/_components/api-list/api-list.component';
import {AppChannelComponent} from './mnews-dist/_components/app-channel/app-channel.component';
import {CasemanagerComponent} from './mnews-dist/_components/casemanager/casemanager.component';

export const appRoutes: Routes = [
    {path: 'mnews', component: AppChannelComponent},
    {path: 'casemanager', component: CasemanagerComponent},
    {path: 'dashboard', component: ApiListComponent},

    // ...caseManagerRoutes
];
